import React, { useState } from "react";
import { observer } from "mobx-react-lite";

import PageLayout from "../../_layout/PageLayout";
import DataGrid from "../../../components/datatable/DataGrid";
import { ViewRemovedUsers } from "../../../services/authorization/Permissions";
import { RemovedUsersStorage } from "../../../services/user/RemovedUsersStorage";
import { api } from "../../../services/api/ApiService";
import { SettingsMenuItemsModel } from "../SettingsMenuItems";

export default observer(() => {
  const [settingsMenuItems] = useState(() => SettingsMenuItemsModel.create({}));

  const [removedUsersStorage] = useState(() => RemovedUsersStorage.create({ useGridFiltering: true }, { api }));

  const menuItems = {
    staticItems: settingsMenuItems.getStaticItems(),
  };

  return (
    <PageLayout
      accessWithOneOfThePermissions={[ViewRemovedUsers]}
      id="view-removed-users"
      titleKey="RemovedUsers.title"
      menuItems={menuItems}
    >
      <DataGrid
        itemTypeKey="general.removed-users"
        dataGridStorage={removedUsersStorage}
        noSelection
      />
    </PageLayout>
  );
});
